export default __webpack_public_path__ + "static/media/image4.04129ba8.jpg";